import React from 'react';

const PageNotFound = () => <div className="text-center">Page Not Found!</div>

export default PageNotFound;